/* eslint-disable no-param-reassign, no-multi-assign, no-underscore-dangle */

import L from 'leaflet';

const containerStyle = `
  position: relative;
  text-shadow:
    -1px -1px 0px #fff,
    1px -1px 0px #fff,
    -1px 1px 0px #fff,
    1px 1px 0px #fff;
    font-weight: bold;
    border-top: none;
    font-size: 12px;
`;

const metricLineStyle = `
  position: absolute;
  bottom: 15px;
  background: url('/images/scale.png');
  height: 20px;
  background-repeat: no-repeat;
  background-size: 100% 150%;
`;

const mCeroStyle = `
  position: absolute;
  bottom: 0px;
  border: none;
  border-top: none;
  background: none;
  color: #000;
  width: 50%;
`;

const mScaleStyle = `
  position: absolute;
  bottom: 0px;
  right: 0px;
  border: none;
  background: none;
  color: #000;
  width: 50%;
`;

L.Control.CustomScale = L.Control.Scale.extend({
  options: {
    position: 'bottomleft',
    maxWidth: 100,
    metric: true,
    imperial: false
  },

  onAdd(map) {
    const container = L.DomUtil.create('div');
    const { options } = this;

    this._addScales(options, container);

    map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
    map.whenReady(this._update, this);
    map.customScale = this;

    container.title = 'Escala';

    return container;
  },
  _addScales(options, container) {
    if (options.metric) {
      const containerMetric = (this._containerMetric = L.DomUtil.create('div'));
      this._metricLine = L.DomUtil.create('div');
      this._mCero = L.DomUtil.create('div');
      this._mScale = L.DomUtil.create('div');

      container.appendChild(containerMetric);
      containerMetric.appendChild(this._metricLine);
      containerMetric.appendChild(this._mCero);
      containerMetric.appendChild(this._mScale);

      containerMetric.style.cssText = containerStyle;
      this._metricLine.style.cssText = metricLineStyle;
      this._mCero.style.cssText = mCeroStyle;
      this._mScale.style.cssText = mScaleStyle;
    }
    if (options.imperial) {
      const containerImperial = (this._containerImperial = L.DomUtil.create('div'));
      this._imperialLine = L.DomUtil.create('div');
      this._iCero = L.DomUtil.create('div');
      this._iCero.innerHTML = '0 km';
      this._iScale = L.DomUtil.create('div');

      container.appendChild(containerImperial);
      containerImperial.appendChild(this._imperialLine);
      containerImperial.appendChild(this._iCero);
      containerImperial.appendChild(this._iScale);

      containerImperial.style.cssText = containerStyle;
      this._imperialLine.style.cssText = metricLineStyle;
      this._iCero.style.cssText = mCeroStyle;
      this._iScale.style.cssText = mScaleStyle;
      this._iCero.innerHTML = '0 km';
    }
  },
  _updateMetric(maxMeters) {
    const meters = this._getRoundNum(maxMeters);
    const label = meters < 1000 ? `${meters} m` : `${meters / 1000} km`;
    this._mCero.innerHTML = meters < 1000 ? `0 m` : `0 km`;

    this._updateScale(
      this._containerMetric,
      this._metricLine,
      this._mScale,
      label,
      meters / maxMeters
    );
  },

  _updateScale(div, line, scale, text, ratio) {
    div.style.width = `${Math.round(this.options.maxWidth * ratio + 30)}px`;
    line.style.width = `${Math.round(this.options.maxWidth * ratio)}px`;
    scale.innerHTML = text;
  }
});
// eslint-disable-next-line func-names
L.control.customscale = function(opts) {
  return new L.Control.CustomScale(opts);
};

/**
 * Adds the custom scale in the leaflet map after the map is loaded.
 *
 * @param {object} leafletMap - The leaflet map.
 */
const customScale = leafletMap => {
  L.control.customscale().addTo(leafletMap);
};

export default customScale;
